import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';
import { toast } from 'react-toastify';
import { setLogout } from '../userSlice';

export const getAllAdminThunk = createAsyncThunk(
  'admin/getAllAdmin',
  async (config, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.exportAdmin(config);
      dispatch(setAdminData(response.data?.data))
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const getAdminThunk = createAsyncThunk(
  'admin/getAdmin',
  async (config, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.getAllAdmin(config);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const addAdminuser = createAsyncThunk(
  'customer/addAdminuser',
  async (data, { rejectWithValue, dispatch }) => {

    try {
      const response = await api.addAdminUser(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const deleteAdminThunk = createAsyncThunk(
  'admin/deleteAdmin',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.deleteAdminUser(id);
      toast.success(response.data?.data?.message || 'success')
      dispatch(setAdminRefresh())
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);


export const updateAdminPasswordThunk = createAsyncThunk(
  'admin/updateAdminPassword',
  async (data, { rejectWithValue, dispatch, getState }) => {

    try {
      const response = await api.updatepassword(data);
      toast.success(response.data?.data?.message || 'success')
      dispatch(setAdminRefresh())

      const state = getState();
      const currentUserId = state.user?.user?._id;

      return {
        status: response.status,
        isCurrentUser: data.id === currentUserId
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || 'something went wrong')
    }
  }
);


export const getAdminDetailsThunk = createAsyncThunk(
  'admin/getAdminDetails',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.getAdminDetails(id);
      return response.data?.data?.data;
    } catch (error) {
      console.log(error);
    }
  }
);


export const editAdminThunk = createAsyncThunk(
  'admin/editAdminThunk',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      const response = await api.editAdmin(data);
      toast.success(response.data?.data?.message || 'success')
      return response.status
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message)
    }
  }
);



// Slice for categories
const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    admindata: [],
    admin: [],
    refresh: false,
    loading: false,
    error: null,
    editAdminData: {},
    page: 1,
    adminDetails: {}
  },
  reducers: {
    setAdminData: (state, action) => {
      state.admin = action.payload
    },
    setAdminRefresh: (state, action) => {
      state.refresh = !state.refresh;
    },
    setEditAdminData: (state, action) => {
      state.editAdminData = action.payload
    },
    setAdminPage: (state, action) => {
      state.page = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAdminThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.admindata = action.payload
      })
      .addCase(getAdminThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getAdminDetailsThunk.pending, (state) => {
        state.loading = true;
      })

      .addCase(getAdminDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.adminDetails = action.payload
      })
      .addCase(getAdminDetailsThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

  },
});

export const { setAdminData, setAdminRefresh, setEditAdminData, setAdminPage } = adminSlice.actions
export default adminSlice.reducer;

